'use strict';

/**
 * @ngdoc function
 * @name prepApp.controller:CourseCtrl
 * @description
 * # CourseController
 * Controller of the prepApp
 */
angular.module('prepApp')
    .controller('CourseController', function ($http, $location, CourseService, NgTableParams, CONFIG, moment, Utils) {
        var vm = this;
        vm.courseList = [];
        vm.eventSources = [];
        vm.printDialog = false;
        vm.printMonth = 1;

        // values for calender
        vm.calendarView = 'month';
        vm.viewDate = new Date();
        vm.events = [];
        moment.locale('de', {
            week: {
                dow: 1 // Monday is the first day of the week
            }
        });

        CourseService.query().$promise.then(function (data) {
            angular.forEach(data, function (course) {
                vm.courseList.push(course);
                var b = new Date(course.begin);
                b.setHours(0);
                var e = new Date(course.end);
                e.setHours(23);
                e.setMinutes(59);
                vm.events.push({
                    title: course.name + ' (' + course.short_name + ') ' + course.count_tasks_finished + '/' + course.count_tasks,
                    startsAt: b, endsAt: e, allDay: true,
                    color: vm.getColor(course.short_name)
                });
            });
            vm.updateCourseList();
        });

        vm.showDialog = function (dialog) {
            vm[dialog] = true;
        };

        vm.updateCourseList = function () {
            var actPage = vm.tableParams.parameters().page;
            vm.tableParams.settings({
                dataset: vm.courseList
            });
            vm.tableParams.page(actPage);
        };

        vm.getColor = function (shortName) {
            if (shortName.startsWith('A-')) {
                return { primary: '#ff0000', secondary: '#ff4e4e' };
            } else if (shortName.startsWith('T-')) {
                return { primary: '#878787', secondary: '#a69d9d' };
            } else if (shortName.startsWith('SB-')) {
                return { primary: '#2183ad', secondary: '#5396c7' };
            } else if (shortName.startsWith('N-') || shortName.startsWith('IN-')) {
                return { primary: '#a85e07', secondary: '#bd741e' };
            } else if (shortName.startsWith('TM-')) {
                return { primary: '#21ad37', secondary: '#53c76d' };
            } else if (shortName.startsWith('TS_')) {
                return { primary: '#ad4321', secondary: '#c77155' };
            }

            return {};
        };

        vm.printCalendar = function (area, month) {
            var pdfURL = CONFIG.backendURL + 'prep/pdf/calendar/' + area + '/' + month + '/';
            Utils.savePDFFile(pdfURL, 'DSV-' + area + '-Kalender.pdf');
            vm.printDialog = false;
        };

        vm.cols = [
            // { valueExpr: 'course.short_name', title: 'Bezeichnung', filter: { short_name: 'text' }, show: true },
            { dataType: 'link', title: 'Bezeichnung', filter: { short_name: 'text' }, show: true },
            { valueExpr: 'course.begin | date:\'dd.MM.yyyy (EEE)\'', title: 'Beginn', sortable: 'begin', show: true },
            { valueExpr: 'course.end | date:\'dd.MM.yyyy (EEE)\'', title: 'Ende', sortable: 'end', show: true },
            { valueExpr: 'course.count_tasks', title: 'Gesamt', filter: { count_tasks: 'number' }, show: true },
            { valueExpr: 'course.count_tasks_finished', title: 'Erledigt', filter: { count_tasks_finished: 'number' }, show: true },
            { field: 'action', title: '', dataType: 'command', class: 'actionWidth120' }
        ];

        vm.tableParams = new NgTableParams({ page: 1, count: 10, sorting: { begin: 'asc' } }, {
            defaultSelectValue: 'Show all',
            dataset: vm.courseList
        });

        vm.viewChangeClicked = function (nextView) {
            if (nextView === 'day') {
                return false;
            }
        };

        vm.getCourseUrl = function (course) {
            return $location.absUrl().replace($location.path(), '/courseTask/' + course.id);
        };

        vm.eventClicked = function (event) {
            $location.path('/courseTask/' + vm.courseList[event.calendarEventId].id);
        };

        vm.createTasks = function (course) {
            vm.selectedCourse = course;
            var creatTasksURL = CONFIG.apiURL + 'courseTasks/' + course.id + '/';

            $http.post(creatTasksURL, {}).then(function () {
                CourseService.get({ id: vm.selectedCourse.id }).$promise.then(function (data) {
                    vm.courseList.splice(vm.courseList.indexOf(vm.selectedCourse), 1);
                    vm.courseList.push(data);
                    vm.updateCourseList();
                });
            });
        };

        vm.deleteTasks = function (course) {
            vm.selectedCourse = course;
            var deleteTasksURL = CONFIG.apiURL + 'courseTasks/' + course.id + '/';

            $http.delete(deleteTasksURL, {}).then(function () {
                CourseService.get({ id: vm.selectedCourse.id }).$promise.then(function (data) {
                    vm.courseList.splice(vm.courseList.indexOf(vm.selectedCourse), 1, data);
                    vm.updateCourseList();
                });
            });
        };

        vm.cancelCourse = function (course) {
            vm.selectedCourse = course;
            var cancelCourseURL = CONFIG.apiURL + 'cancelCourse/' + course.id + '/';

            $http.post(cancelCourseURL, {}).then(function () {
                CourseService.get({ id: vm.selectedCourse.id }).$promise.then(function (data) {
                    vm.courseList.splice(vm.courseList.indexOf(vm.selectedCourse), 1);
                    vm.courseList.push(data);
                    vm.updateCourseList();
                });
            });
        };
    });
